import React, { useState, useEffect } from "react";
import NavbarVisitor from '../Component/NavbarVisitor';
import axios from "axios";
import { BASE_URL } from '../Component/Baseurl';
import Footer from "../Component/Footer";
import Swal from 'sweetalert2'; // Import SweetAlert2
import ProfileNavbar from "../Component/ProfileNavbar";

const ProfileMain = () => {
  // Define form state
  const [formData, setFormData] = useState({
    salutation: "",
    name: "",
    email: "",
    phone: "",
    countryCode: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    gender: "",
    designation: ""
  });

  const [originalData, setOriginalData] = useState({}); // To store original profile data
  const [message, setMessage] = useState(null); // To display success or error messages
  const [error, setError] = useState(null); // For error messages
  const [isEdited, setIsEdited] = useState(false); // To track if the form has been edited
  const [countryCodes, setCountryCodes] = useState([]); // To store country codes list
  const [phoneError, setPhoneError] = useState(""); // To store phone number error message

  // Fetch user profile on component mount
  useEffect(() => {
    const fetchProfile = async () => {
      const visitorId = localStorage.getItem('visitor_id');
      if (visitorId) {
        try {
          const response = await axios.get(`${BASE_URL}/getProfile/${visitorId}`);
          if (response.data.success) {
            const userData = response.data.data;
            setFormData({ 
              salutation: userData.salutation,  // Add salutation
              name: userData.name,
              email: userData.email,
              phone: userData.phone,
              countryCode: userData.country_code,
              address: userData.address,
              city: userData.city,
              state: userData.state,
              country: userData.country,
              pincode: userData.pincode,
              gender: userData.gender,  // Add gender
              designation: userData.designation  // Add designation
              
            });
            setOriginalData(userData); // Store original data
          } else {
            setError("Failed to fetch profile.");
          }
        } catch (err) {
          console.error("Error fetching profile:", err);
          setError("An error occurred while fetching the profile.");
        }
      }
    };

    // Fetch the country codes list (this can be a static list or from an API)
    const fetchCountryCodes = async () => {
      try {
        // Static list of country codes for demo purposes
        const codes = [
          { code: "+1", country: "USA" },
          { code: "+91", country: "India" },
          { code: "+44", country: "UK" },
          { code: "+61", country: "Australia" },
          { code: "+81", country: "Japan" }
        ];
        setCountryCodes(codes); // Set country codes state
      } catch (err) {
        console.error("Error fetching country codes:", err);
      }
    };

    fetchProfile();
    fetchCountryCodes(); // Call to fetch country codes
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Phone number validation (only 10 digits allowed)
    if (name === "phone") {
      if (/^\d{0,10}$/.test(value)) {
        setPhoneError(""); // Clear error message when input is valid
      } else {
        setPhoneError("Phone number must be 10 digits.");
      }
    }

    setFormData((prevData) => {
      const newData = { ...prevData, [name]: value };
      // Check if any form field is different from the original data
      setIsEdited(JSON.stringify(newData) !== JSON.stringify(originalData));
      return newData;
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const visitorId = localStorage.getItem('visitor_id');
  
    // Prepare data to send as JSON
    const data = {
      id: visitorId, 
      salutation: formData.salutation,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      countryCode: formData.countryCode,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      pincode: formData.pincode,
      gender: formData.gender,
      designation: formData.designation
    };
  
    console.log("Data being sent:", data);
  
    try {
      // Send data as JSON
      const response = await axios.post(`${BASE_URL}updateProfile`, data, {
        headers: { "Content-Type": "application/json" }
      });
  
      console.log("Response from the server:", response.data);
  
      if (response.data.success) {
        // Show SweetAlert2 success popup with custom styles
        Swal.fire({
          title: 'Success!',
          text: 'Profile updated successfully!',
          icon: 'success',
          confirmButtonText: 'Go To Home',
          customClass: {
            container: 'custom-container',
            title: 'custom-title',
            content: 'custom-content',
            confirmButton: 'custom-button'
          },
          buttonsStyling: false
        }).then(() => {
          // Reload the page after the "Okay" button is clicked
        //   window.location.reload();
          window.location.href = '/';

        });
  
        // Update visitor_name in localStorage
        localStorage.setItem("visitor_name", formData.name);
  
        // Log the updated visitor_name value
        console.log("Updated visitor_name in localStorage:", localStorage.getItem("visitor_name"));
  
        // Optionally, update original data after successful submit
        setOriginalData(formData);
      } else {
        setError("Failed to update profile.");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      setError("An error occurred while updating the profile.");
    }
  };
  
  

  return (
    <>
      {/* <NavbarVisitor /> */}
      <section>
        <div className="container-fluid">
          <div className="row justify-content-center">
            
            <div className="col-md-9">
              <div className="bg-salt mt-3 p-2 py-3 mb-3 text-start">
                <h2 className="text-start hedng">User Profile</h2>

                {message && <div className="alert alert-success">{message}</div>}
                {error && <div className="alert alert-danger">{error}</div>}

                <div className="row justify-content-center">
                  <div className="col-md-9">
                    <form onSubmit={handleSubmit}>
                      <div className="row">

                        {/* Salutation Dropdown */}
                        <div className="col-md-3">
                          <div className="mb-2">
                            <label className="form-label">Salutation <span className="text-danger">*</span></label>
                            <select
                              name="salutation"
                              value={formData.salutation}
                              onChange={handleChange}
                              className="forminput" required
                            >
                              <option value="">Select Salutation</option>
                              <option value="Mr">Mr</option>
                              <option value="Mrs">Mrs</option>
                              <option value="Miss">Miss</option>
                              <option value="Dr">Dr</option>
                              <option value="Prof">Prof</option>
                            </select>
                          </div>
                        </div>

                        {/* Name Field */}
                        <div className="col-md-9">
                          <div className="mb-2">
                            <label className="form-label">Name <span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className="forminput"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              placeholder="Enter Name" required
                            />
                          </div>
                        </div>

                        {/* Email Field */}
                        <div className="col-md-12">
                          <div className="mb-2">
                            <label className="form-label">Email <span className="text-danger">*</span></label>
                            <input
                              type="email"
                              className="forminput"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              placeholder="Enter Email" readOnly 
                            />
                          </div>
                        </div>

                        {/* Gender Dropdown */}
                        <div className="col-md-3">
                          <div className="mb-2">
                            <label className="form-label">Gender</label>
                            <select
                              name="gender"
                              value={formData.gender}
                              onChange={handleChange}
                              className="forminput"
                            >
                              <option value="">Select Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Other">Other</option>
                            </select>
                          </div>
                        </div>


                        

                        {/* Country Code Dropdown */}
                        <div className="col-md-3">
                          <div className="mb-2">
                            <label className="form-label">Country Code <span className="text-danger">*</span></label>
                            <select
                              name="countryCode"
                              value={formData.countryCode}
                              onChange={handleChange}
                              className="forminput" required
                            >
                              <option value="">Select Country Code</option>
                              {countryCodes.map((code) => (
                                <option key={code.code} value={code.code}>
                                  {code.code} ({code.country})
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {/* Phone Number */}
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label">Mobile Number <span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className="forminput"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              placeholder="Enter Phone Number" required
                            />
                            {phoneError && <small className="text-danger">{phoneError}</small>}
                          </div>
                        </div>



                        <div className="mt-3">
                        <h2 className="text-start hedng">Company Details</h2>
                        
                        </div>


                        <div className="col-md-12">
                          <div className="mb-2">
                            <label className="form-label">Designation</label>
                            <input
                              type="text"
                              className="forminput"
                              name="designation"
                              value={formData.designation}
                              onChange={handleChange}
                              placeholder="Enter Designation"
                            />
                          </div>
                        </div>

                        {/* Address */}
                        <div className="col-md-12">
                          <div className="mb-2">
                            <label className="form-label">Address</label>
                            <input
                              type="text"
                              className="forminput"
                              name="address"
                              value={formData.address}
                              onChange={handleChange}
                              placeholder="Enter Address"
                            />
                          </div>
                        </div>

                        {/* City */}
                        <div className="col-md-4">
                          <div className="mb-2">
                            <label className="form-label">City</label>
                            <input
                              type="text"
                              className="forminput"
                              name="city"
                              value={formData.city}
                              onChange={handleChange}
                              placeholder="Enter City"
                            />
                          </div>
                        </div>

                        {/* State */}
                        <div className="col-md-4">
                          <div className="mb-2">
                            <label className="form-label">State</label>
                            <input
                              type="text"
                              className="forminput"
                              name="state"
                              value={formData.state}
                              onChange={handleChange}
                              placeholder="Enter State"
                            />
                          </div>
                        </div>

                        {/* Country */}
                        <div className="col-md-4">
                          <div className="mb-2">
                            <label className="form-label">Country <span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className="forminput"
                              name="country"
                              value={formData.country}
                              onChange={handleChange}
                              placeholder="Enter Country"

                              required
                            />
                          </div>
                        </div>

                        {/* Pincode */}
                        <div className="col-md-12">
                          <div className="mb-2">
                            <label className="form-label">Pincode <span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className="forminput"
                              name="pincode"
                              value={formData.pincode}
                              onChange={handleChange}
                              placeholder="Enter Pincode"
                              required
                            />
                          </div>
                        </div>

                        {/* Submit Button */}
                        <div className="col-md-12">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={!isEdited || phoneError} // Disable submit if form is not edited or phone number is invalid
                          >
                            Save Changes
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ProfileMain;
